
import { defineComponent } from 'vue';

import PrzBlock from '@/components/Blocks/Block/Desktop.vue';
import PrzLoader from '@/components/Muffin/Loader.vue';
import WithInfiniteScroll from '@/components/Blocks/WithInfiniteScroll.vue';

export default defineComponent({
    extends: WithInfiniteScroll,
    components:{
        PrzBlock,
        PrzLoader
    },
});
